import { connect } from 'react-redux';
import Loan from './Loan';

import {
    setLoanTerm,
    setDownPayment,
    setLoanInterest,
    setMosaicTerm,
    setMosaicDownPayment,
    setLoanProvider,
    setShowLoan,
} from '../../common/loan/actions';

import { setLoanIsVisible } from './actions';

import { setSelectedFinancing } from '../../common/settings/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    loanTerm: state.loan.loanTerm,
    downPayment: state.loan.downPayment,
    loanInterest: state.loan.interest,
    mosaicTerm: state.loan.mosaicTerm,
    mosaicDownPayment: state.loan.mosaicDownPayment,
    loanProvider: state.loan.loanProvider,
    isVisible: state.loanUI.isVisible,
    showLoan: state.loan.showLoan,
    setSelectedFinancing,
    setShowLoan,
    setLoanIsVisible,
    setLoanInterest,
    setLoanTerm,
    setDownPayment,
    setMosaicTerm,
    setMosaicDownPayment,
    setLoanProvider,
});

const combinedActions = {
    setSelectedFinancing,
    setLoanIsVisible,
    setLoanInterest,
    setLoanTerm,
    setDownPayment,
    setMosaicTerm,
    setMosaicDownPayment,
    setLoanProvider,
    setShowLoan,
};

export default connect(mapStateToProps, combinedActions)(Loan);



// WEBPACK FOOTER //
// ./src/containers/Inputs/Loan/index.js